import * as React from "react";
import "./LevelIndicator.component.css";
import { useLocalMicLevel } from "../../../../hooks/mic-indicator.hook";
import { useEffect, useState } from "react";
const levelIndicatorResolution = 10;
const points = [];
for (let i = 0; i <= levelIndicatorResolution; i++) {
    let color = "green";
    if (i === levelIndicatorResolution) {
        color = "red";
    }
    else if (i === levelIndicatorResolution - 1 || i === levelIndicatorResolution - 2) {
        color = "yellow";
    }
    points.push(color);
}
export function LevelIndicator() {
    const [level, threshold] = useLocalMicLevel();
    const [currentLevel, setCurrentLevel] = useState(-Infinity);
    const [currentPointsCount, setCurrentPointsCount] = useState(0);
    const [currentMaxPoint, setCurrentMaxPoint] = useState(-1);
    useEffect(() => {
        setCurrentLevel(level);
    }, [level]);
    useEffect(() => {
        let activePoints = 0;
        if (level > 0) {
            activePoints = levelIndicatorResolution + 1;
        }
        else if (level > threshold) {
            const step = threshold / levelIndicatorResolution;
            activePoints = Math.floor(level / step);
        }
        if (activePoints < currentMaxPoint + 1) {
            setTimeout(() => {
                setCurrentMaxPoint(-1);
            }, 2000);
        }
        else {
            setCurrentMaxPoint(activePoints - 1);
        }
        setCurrentPointsCount(activePoints);
    }, [currentLevel]);
    const createLevelPoints = () => {
        return points.map((color, index) => {
            const active = index < currentPointsCount;
            return (React.createElement("div", { className: "level-indicator-element", key: index },
                React.createElement("div", { className: `level-indicator-point level-indicator-point-${active ? color : "grey"}` }),
                React.createElement("div", { className: `level-indicator-spacer ${index === currentMaxPoint ? "level-indicator-spacer-max" : ""}` })));
        });
    };
    return React.createElement("div", { className: "level-indicator-container" }, createLevelPoints());
}
